import { render } from "./CveBoard.vue?vue&type=template&id=7642f17a"
import script from "./CveBoard.vue?vue&type=script&lang=js"
export * from "./CveBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__